package com.schoolconnect.app.feature.schools.edit

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.schoolconnect.app.feature.schools.SchoolRowUi

@Composable
fun EditSchoolFeatureRoute(
    onBack: () -> Unit,
    initialValues: EditSchoolFormValues = defaultEditSchoolFormValues(),
    school: SchoolRowUi? = null,
    onSaved: (EditSchoolFormValues) -> Unit = {}
) {
    val viewModel = remember(initialValues, school?.code) {
        EditSchoolViewModel(
            schoolCode = school?.code.orEmpty(),
            initialValues = initialValues,
            loadFromRemote = school?.code?.isNotBlank() == true,
            onSaved = onSaved
        )
    }
    val uiState by viewModel.uiState.collectAsState()

    DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }

    EditSchoolScreen(
        state = uiState,
        onEvent = viewModel::onEvent,
        onBack = onBack
    )
}
